import { ropoloRequest } from '../axios';

const clubsPointList = async () => (await ropoloRequest.clubsPointList())?.data;

const clubsEarnPreview = async (orderId: string) => (await ropoloRequest.clubsEarnpointPreviewDetail(orderId))?.data;

const clubPointDetail = async (orderId: string) => (await ropoloRequest.clubsEarnpointDetail(orderId))?.data;

export { clubsPointList, clubsEarnPreview, clubPointDetail };
